import FileSaver from 'file-saver';
import {
    GENERATE_PDF,
    DOWNLOAD_PDF,
    CLOSE_SNACK_BAR,
} from '../../actionTypes/shared/apiActionTypes';
import PdfGeneratorClient from '../../clients/shared/PdfGeneratorClient';
import { apiActionCreator } from '../../actionCreators';

export const generatePdf = (pdfConfiguration, preApiCallCalback) => async dispatch => {
    const additionalApiParams = {
        additionalResponseParams: pdfConfiguration,
        preApiCallCalback,
        isNeededStartAction: false,
    };

    await apiActionCreator(dispatch, { SUCCESS: GENERATE_PDF }, () => {}, additionalApiParams);
};

export const closeSnackbar = () => ({
    type: CLOSE_SNACK_BAR,
});

export const downloadPdf = (url, pdfData, pdfFileName) => async dispatch => {
    const additionalApiParams = {
        afterApiCallCalback: async response => {
            await FileSaver.saveAs(new Blob([response], { type: 'application/pdf' }), pdfFileName);
        },
        apiParams: [url, pdfData],
    };
    await apiActionCreator(
        dispatch,
        DOWNLOAD_PDF,
        PdfGeneratorClient.downloadPdfFile,
        additionalApiParams,
    );
};
